export default __webpack_public_path__ + "static/media/dbs.1980da93.jpg";